<template>
  <v-flex xs12 d-flex text-xs-center>
    <v-layout row wrap>
      <v-snackbar
        v-model="error.show"
        color="error"
        top
        :timeout="error.timeout"
        text-xs-center
      >
        {{ error.message }}
        <v-icon right dark>error_outline</v-icon>
      </v-snackbar>

      <v-snackbar
        v-model="languageLabor.show"
        color="warning"
        top
        :timeout="languageLabor.timeout"
        text-xs-center
      >
        {{ languageLabor.message }}
        <v-icon right dark>error_outline</v-icon>
      </v-snackbar>

      <v-toolbar dark color="#b6d000" class="m-3">
        <v-toolbar-title class="white--text">
          Angol alapfokú képzés
        </v-toolbar-title>
      </v-toolbar>

      <transition name="fadeSlow">
        <v-flex xs12 md7 order-xs2 order-md1 v-show="!expiredSubscription.show">
          <v-layout row wrap class="mt-5">
            <v-flex
              xs12
              v-for="(chapter, indexChapter) in chapters"
              v-bind:key="indexChapter"
            >
              <v-card v-if="indexChapter !== 0" class="stepFieldHint">
                A fejezet elkezdéséhez
                <strong> {{ chapter.star_limit }} </strong>
                <img
                  :src="require('@/assets/img/star_shadow.png')"
                  height="35px"
                  class="mb-2"
                />
                szükséges
              </v-card>

              <v-layout row wrap text-xs-center>
                <v-flex xs12 text-xs-left>
                  <h2>
                    {{ chapter.title }}
                    <v-btn
                      fab
                      color="info"
                      dark
                      small
                      @click="chapterInfo(chapter)"
                    >
                      <!-- Információ -->
                      <v-icon>info</v-icon>
                    </v-btn>
                  </h2>
                </v-flex>
                <v-flex
                  v-for="(lesson, index) in chapter.lessons"
                  v-bind:class="dynamicLessonItem(lesson, index + 1)"
                  v-bind:key="index"
                >
                  <div
                    v-if="
                      lesson.completedCounter !== undefined &&
                        lesson.completedCounter > 0
                    "
                    class="star text-center"
                  >
                    {{ lesson.completedCounter }}
                  </div>
                  <div v-else class="starDisabled"></div>

                  <div v-if="lesson.enableLink">
                    <a
                      href="javascript:void(0)"
                      @click="checkStar(chapter, lesson)"
                    >
                      <div
                        class="text-center"
                        v-bind:class="dynamicLessonElement(lesson.countNumber)"
                        v-bind:id="lesson.countNumber"
                      >
                        {{ lesson.countNumber }}
                      </div>
                    </a>
                  </div>
                  <div v-else>
                    <a
                      href="javascript:void(0)"
                      @click="disabledLesson.show = true"
                    >
                      <div
                        class="text-center"
                        v-bind:class="dynamicLessonElement(lesson.countNumber)"
                        v-bind:id="lesson.countNumber"
                      >
                        {{ lesson.countNumber }}
                      </div>
                    </a>
                  </div>
                </v-flex>
              </v-layout>
              <div class="mileStoneHolder">
                <v-divider></v-divider>
                <img
                  :src="require('@/assets/img/milestoneinactive.png')"
                  class="mileStone"
                />
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </transition>
      <transition name="fadeSlow">
        <v-flex xs12 md5 order-xs1 order-md2 v-show="!expiredSubscription.show">
          <v-layout row wrap>
            <v-flex xs12>
              <v-card class="resultsPanel elevation-8">
                <h4 class="pt-2">Eredmények</h4>
                <v-layout row wrap>
                  <v-flex xs4 text-xs-center justify-center>
                    <v-layout row wrap>
                      <v-flex xs6 text-xs-right>
                        <img
                          :src="require('@/assets/img/footprint_mod_1.png')"
                          class="stepFieldBadgeImages"
                        />
                      </v-flex>
                      <v-flex xs6 text-xs-left class="result">
                        {{ allSteps }}
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs4>
                    <v-layout row wrap>
                      <v-flex xs6 text-xs-right>
                        <img
                          :src="require('@/assets/img/new_lingron.png')"
                          class="stepFieldBadgeImages"
                        />
                      </v-flex>
                      <v-flex
                        xs6
                        text-xs-left
                        vertical
                        align-center
                        fill-height
                        class="result justify-content-center"
                      >
                        {{ allLingrons }}
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs4>
                    <v-layout row wrap>
                      <v-flex xs6 text-xs-right>
                        <img
                          :src="require('@/assets/img/star_shadow.png')"
                          class="stepFieldBadgeImages"
                        />
                      </v-flex>
                      <v-flex
                        xs6
                        text-xs-left
                        vertical
                        align-center
                        fill-height
                        class="result justify-content-center"
                      >
                        {{ allStars }}
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <!-- <v-flex hidden-sm-and-down md12>
                            <v-card class="nyelviLaborPanel elevation-8" @click="languageLabor.show1 = true">
                                <img :src="require('@/assets/img/nyelvi_labor.png')" class="stepFieldNyelviLaborImage" />
                            </v-card>
                        </v-flex> -->
            <v-flex hidden-sm-and-down md12>
              <v-card class="regPanel elevation-8 p-2">
                <v-alert
                  :value="true"
                  type="info"
                  class="registrationFormInfoAlert"
                >
                  Az eredményeid elmentéséhez regisztrálj egy profilt.
                </v-alert>
                <v-card-text>
                  <v-form class="p-2">
                    <v-text-field
                      prepend-icon="person"
                      name="name"
                      label="Név"
                      type="text"
                      :rules="[rules.required]"
                      v-model="form.name"
                    ></v-text-field>
                    <v-text-field
                      prepend-icon="alternate_email"
                      name="login"
                      label="E-mail cím"
                      type="text"
                      :rules="[rules.required]"
                      v-model="form.email"
                    ></v-text-field>
                    <v-text-field
                      prepend-icon="alternate_email"
                      name="login"
                      label="E-mail cím megerősítése"
                      type="text"
                      :rules="[rules.required]"
                      v-model="form.email2"
                    ></v-text-field>
                    <v-text-field
                      prepend-icon="lock"
                      name="password"
                      label="Jelszó"
                      :rules="[rules.required]"
                      :append-icon="
                        form.passwordShow ? 'visibility' : 'visibility_off'
                      "
                      :type="form.passwordShow ? 'text' : 'password'"
                      @click:append="form.passwordShow = !form.passwordShow"
                      v-model="form.password"
                    ></v-text-field>
                    <v-text-field
                      prepend-icon="lock"
                      name="password"
                      label="Jelszó"
                      :rules="[rules.required]"
                      :append-icon="
                        form.passwordShow2 ? 'visibility' : 'visibility_off'
                      "
                      :type="form.passwordShow2 ? 'text' : 'password'"
                      @click:append="form.passwordShow2 = !form.passwordShow2"
                      v-model="form.password2"
                    ></v-text-field>
                    <v-checkbox v-model="form.checkbox.aszf">
                      <template v-slot:label>
                        <a
                          target="_blank"
                          href="https://admin.skillers.hu/skillers_aszf.pdf"
                        >
                          Elfogadom az Általános Szerződési Feltételeket
                        </a>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-model="form.checkbox.gdpr">
                      <template v-slot:label>
                        <a
                          target="_blank"
                          href="https://admin.skillers.hu/skillers_gdpr.pdf"
                        >
                          Elolvastam és elfogadtam az adatkezelési tájékoztatót
                        </a>
                      </template>
                    </v-checkbox>
                  </v-form>
                </v-card-text>
                <v-card-actions text-xs-center>
                  <v-btn color="primary" @click="letsRegistrate">
                    Regisztráció
                    <v-icon right dark>input</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </transition>

      <transition name="fadeSlow">
        <v-flex xs12 md5 order-xs1 order-md2 v-show="!expiredSubscription.show">
        </v-flex>
      </transition>

      <v-dialog v-model="registration.show" persistent max-width="600px">
        <v-card class="elevation-12">
          <v-toolbar dark color="#2d4d85">
            <v-toolbar-title>Regisztráció</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text class="regCard">
            <v-alert :value="true" type="info">
              A kezdéshez regisztrálj egy ingyenes profilt.
            </v-alert>

            <v-form class="p-2">
              <v-text-field
                prepend-icon="person"
                name="name"
                label="Név"
                type="text"
                :rules="[rules.required]"
                v-model="form.name"
              ></v-text-field>
              <v-text-field
                prepend-icon="alternate_email"
                name="login"
                label="E-mail cím"
                type="text"
                :rules="[rules.required]"
                v-model="form.email"
              ></v-text-field>
              <v-text-field
                prepend-icon="alternate_email"
                name="login"
                label="E-mail cím megerősítése"
                type="text"
                :rules="[rules.required]"
                v-model="form.email2"
              ></v-text-field>
              <v-text-field
                prepend-icon="lock"
                name="password"
                label="Jelszó"
                :rules="[rules.required]"
                :append-icon="
                  form.passwordShow ? 'visibility' : 'visibility_off'
                "
                :type="form.passwordShow ? 'text' : 'password'"
                @click:append="form.passwordShow = !form.passwordShow"
                v-model="form.password"
              ></v-text-field>
              <v-text-field
                prepend-icon="lock"
                name="password"
                label="Jelszó"
                :rules="[rules.required]"
                :append-icon="
                  form.passwordShow2 ? 'visibility' : 'visibility_off'
                "
                :type="form.passwordShow2 ? 'text' : 'password'"
                @click:append="form.passwordShow2 = !form.passwordShow2"
                v-model="form.password2"
              ></v-text-field>
              <v-checkbox v-model="form.checkbox.aszf">
                <template v-slot:label>
                  <a
                    target="_blank"
                    href="https://admin.skillers.hu/skillers_aszf.pdf"
                  >
                    Elfogadom az ÁSZF-t
                  </a>
                </template>
              </v-checkbox>
              <v-checkbox v-model="form.checkbox.gdpr">
                <template v-slot:label>
                  <a
                    target="_blank"
                    href="https://admin.skillers.hu/skillers_gdpr.pdf"
                  >
                    Elolvastam és elfogadtam az adatkezelési tájékoztatót
                  </a>
                </template>
              </v-checkbox>
            </v-form>
          </v-card-text>
          <v-card-actions class="regAction">
            <v-spacer></v-spacer>
            <!-- <v-btn color="error" @click="registration.show = !registration.show"> -->
            <v-btn color="error" @click="$router.push({ name: 'main' })">
              <v-icon left dark>chevron_left</v-icon>
              Vissza
            </v-btn>
            <v-btn color="primary" @click="letsRegistrate()">
              Regisztráció
              <v-icon right dark>input</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="loader" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Regisztráció folyamatban
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogChapterInfo.show" width="600">
        <v-toolbar color="bgBlue" dark>
          <v-toolbar-title
            >Információ - {{ dialogChapterInfo.title }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogChapterInfo.show = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card>
          <v-card-text @click="dialogChapterInfo.show = false">
            <p>{{ dialogChapterInfo.description }}</p>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="languageLabor.show1" width="600">
        <v-card>
          <v-card-title class="headline bgBlue dark text-light" primary-title>
            Nyelvi labor

            <v-spacer></v-spacer>

            <v-btn color="error" fab small @click="languageLabor.show1 = false">
              <v-icon class="text-light">close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text @click="goToEEgytemLogIn">
            <img
              :src="require('@/assets/img/tipp3.png')"
              alt="tipp1"
              class="img-responsive"
            />
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-flex>
</template>

<script>
import axios from "axios";
import LeaderLine from "leader-line";

export default {
  data: () => ({
    loader: false,
    loginShow: false,
    registration: {
      show: true
    },
    subscription: null,
    course: null,
    chapters: null,
    showLine: true,
    lines: [],
    counter: 0,
    dynamicFlex: "xs12",
    showContent: false,
    allSteps: 0,
    allLingrons: 0,
    allStars: 0,
    nextLessonId: 0,
    lastCompletedLessonId: 0,
    dialogChapterInfo: {
      show: false,
      title: "",
      description: ""
    },
    disabledLesson: {
      show: false,
      message: "Teljesítsd a korábbi leckéket!",
      timeout: 4000
    },
    disabledLessonByStar: {
      show: false,
      message: "Nem gyűjtöttél elég csillagot a fejezethez!",
      timeout: 4000
    },
    expiredSubscription: {
      show: false,
      message: "Az Ön előfizetése lejárt!"
    },
    form: {
      email: "",
      email2: "",
      name: "",
      password: "",
      passwor2: "",
      passwordShow: false,
      passwordShow2: false,
      checkbox: {
        aszf: false,
        gdpr: false
      }
    },
    languageLabor: {
      show: false,
      show1: false,
      message: "Csak előfizetőknek elérhető!",
      timeout: 4000
    },
    error: {
      show: false,
      code: "",
      message: "",
      timeout: 4000
    },
    rules: {
      required: value => !!value || "Kötelező"
    }
  }),
  methods: {
    getStepFieldData() {
      //Reset all counter
      this.$store.commit("updateLastQuestion", {
        lastQuestionId: null
      });

      this.$store.commit("updateProgressIndicator", {
        progressIndicator: 0
      });

      this.$store.commit("setMaxLingron", {
        maxLingron: 0
      });

      this.$store.commit("updateStepCounter", {
        stepCounter: 0
      });

      this.$store.commit("updateLingronCounter", {
        lingronCounter: 0
      });

      axios
        .post(this.$store.getters.getApiUrl + "/api/registration/landing", {
          sample: true
        })
        .then(response => {
          // console.log('stepfield - resp: ', response.data);
          this.$data.chapters = response.data.chapters;
          this.$data.allSteps = 0;
          this.$data.allLingrons = 0;
          this.$data.allStars = 0;
          this.$data.nextLessonId = response.data.nextLessonId;
          this.$data.lastCompletedLessonId =
            response.data.lastCompletedLessonId;
          this.$data.showContent = true;

          var v = this;
          setTimeout(function() {
            v.drawLine();
          }, 200);
        })
        .catch(error => {
          if (error.length > 0) {
            console.log("stepfield- error: ", error);
          }
        });
    },
    chapterInfo(chapter) {
      this.$data.dialogChapterInfo.title = chapter.title;
      this.$data.dialogChapterInfo.description = chapter.description;
      this.$data.dialogChapterInfo.show = true;
    },
    letsRegistrate() {
      this.$data.error.show = false;

      if (
        this.$data.form.checkbox.aszf === false ||
        this.$data.form.checkbox.gdpr === false
      ) {
        this.$data.error.message = "ÁSZF és GDPR elfogadása kötelező!";
        this.$data.error.code = "000";
        this.$data.error.show = true;
      } else if (
        this.$data.form.email.length < 1 ||
        this.$data.form.name.length < 1
      ) {
        this.$data.error.message = "Az email címeknek egyezniük kell!";
        this.$data.error.code = "000";
        this.$data.error.show = true;
      } else if (this.$data.form.email !== this.$data.form.email2) {
        this.$data.error.message = "Az email címeknek egyezniük kell!";
        this.$data.error.code = "000";
        this.$data.error.show = true;
      } else if (this.$data.form.password !== this.$data.form.password2) {
        this.$data.error.message = "Az jelszavaknak egyezniük kell!";
        this.$data.error.code = "000";
        this.$data.error.show = true;
      } else {
        this.$data.loader = true;

        axios
          .post(this.$store.getters.getApiUrl + "/api/registration", {
            email: this.$data.form.email,
            password: this.$data.form.password,
            name: this.$data.form.name
          })
          .then(response => {
            if (response.data.token !== undefined) {
              this.$store.commit("loginSuccess", {
                token: response.data.token,
                isLoggedIn: true,
                currentUser: response.data.currentUser
              });

              var v = this;
              setTimeout(function() {
                v.$data.loader = false;
                v.$router.push({ path: "/home" });
              }, 2000);
            }
          })
          .catch(error => {
            // console.log('Hibas reg: ', error.response);
            this.$data.loader = false; // Stop the loader
            this.$data.error.message = error.response.data.message;
            this.$data.error.code = error.response.data.code;
            this.$data.error.show = true;
          });
      }
    },
    checkStar(chapter, lesson) {
      //We dont check anything, just redirect to registration page
      //this.$router.push({ name: 'registration'});
      if (lesson.countNumber === 1) {
        this.$store.commit("setCurrentLessonId", {
          currentLessonId: lesson.id
        });

        this.$router.push({
          name: "registrationLandingQuestion",
          params: { lessonId: 4 }
        });
      }

      this.$data.registration.show = true;
    },
    drawLine() {
      //The indes is the countNumber
      var lines = [];

      if (this.$data.chapters.length !== null) {
        var v = this; //To acces this variables in loops

        this.$data.chapters.map(function(chapter, key1) {
          var lineCounter = 0;

          chapter.lessons.map(function(lesson, key2) {
            if (
              lesson.lastLessonInChapter === false ||
              lesson.lastLessonInChapter === undefined
            ) {
              //Select DOM elements
              var start = document.getElementById(lesson.countNumber);
              var end = document.getElementById(lesson.countNumber + 1);

              //Check the DOM element exist or not
              if (
                typeof start != "undefined" &&
                start != null &&
                typeof end != "undefined" &&
                end != null
              ) {
                //Def line options
                let color = "#FF3088";
                let animation = true;
                let size = 4;

                if (!lesson.enableLink || v.$data.nextLessonId === lesson.id) {
                  color = "#C6C6C6";
                  animation = false;
                }

                //Horizontal line or default line
                if (
                  lineCounter === 1 ||
                  lineCounter === 4 ||
                  lineCounter === 6
                ) {
                  var newLine = new LeaderLine(start, end, {
                    dash: { animation: animation },
                    endPlug: "behind",
                    startSocket: "bottom",
                    endSocket: "left",
                    color: color,
                    size: size
                  });
                } //Default line
                else {
                  var newLine = new LeaderLine(start, end, {
                    dash: { animation: animation },
                    endPlug: "behind",
                    startSocket: "bottom",
                    endSocket: "top",
                    color: color,
                    size: size
                  });
                }

                lines.push(newLine); //Store the line to an array
              }
            }

            // console.log('Line counter: ',lineCounter);
            lineCounter++;
          });
        });
      }

      this.$data.lines = lines;
    },
    deleteLine() {
      var lines = this.$data.lines;

      if (lines.length > 1) {
        lines.map(function(line, key) {
          line.remove();
        });
      }
    },
    dynamicLessonElement(index) {
      if (index < 10) {
        return "stepFieldElementOneNumber";
      } else {
        return "stepFieldElement";
      }
    },
    dynamicLessonItem(lesson, index) {
      let classNames = "stepFieldItem ";

      //If active
      if (this.$data.lastCompletedLessonId >= lesson.id) {
        classNames = "stepFieldItemSuccess ";
      }

      //If it is the next lesson
      if (this.$data.nextLessonId === lesson.id) {
        classNames = "stepFieldItemNext ";
      }

      if (index === 1) {
        classNames += "xs12 text-sm-center mb-2";
      }

      if (index === 2 || index === 3) {
        if (index === 2) {
          classNames += "xs6 offset-md3 md3 text-sm-center mb-2";
        } else {
          classNames += "xs6 md3 text-sm-center mt-4 mb-2";
        }
      }

      if (index === 4) {
        classNames += "xs12 text-sm-center mb-2";
      }

      if (index === 5 || index === 6) {
        if (index === 5) {
          classNames += "xs6 offset-md3 md3 text-sm-center mb-2";
        }
        if (index === 6) {
          classNames += "xs6 md3 text-sm-center mb-2 mt-4";
        }
      }

      if (index === 7 || index === 8) {
        if (index === 7) {
          classNames += "xs6 offset-md3 md3 text-sm-center mt-2 mb-2";
        }
        if (index === 8) {
          classNames += "xs6 md3 text-sm-center mt-4 mb-2";
        }
      }

      if (index === 9) {
        classNames += "xs12 text-sm-center mb-2";
      }

      return classNames;
    },
    goToEEgytemLogIn() {
      if (
        this.$data.subscription !== null &&
        this.$data.subscription.package_id !== 7
      ) {
        //If not free trial or test user
        window.open(this.$store.getters.getEEgyetemLoginUrl, "_blank");
      } else {
        this.$data.languageLabor.show = true;
      }
    }
  },
  beforeUpdate: function() {
    // this.deleteLine();
  },
  updated: function() {
    // this.drawLine();
  },
  created: function() {
    this.getStepFieldData();
    this.deleteLine();
  },
  destroyed: function() {
    this.deleteLine();
  }
};
</script>
